import axios from 'axios';
import { Toast } from 'vant';
/**
 * 获取localSorage对应字段
 * @param {String} properName
 */
const getValue = properName => localStorage.getItem(properName)

const service = axios.create({
    timeout: 60 * 1000,
    headers: {
        'Content-Type': 'application/json; charset=utf-8',
    },
});

Toast.allowMultiple();
function startLoading() {
    Toast.loading({
        message: '加载中...',
        forbidClick: true,
    });
}
function endLoading() {
    Toast.clear()
}

service.interceptors.request.use(
    config => {
        // function isWeiXin() {
        //     var ua = window.navigator.userAgent.toLowerCase();
        //     if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //       return true;
        //     } else {
        //       return false;
        //     }
        // }
        let token = getValue("token");
        let target = {systemcode:"GD",
                      accountType:"XJ",
                      token:window.localStorage.getItem('token'),
                    //   EmPbNSyNA150dDv0yuaCt_eT3Fkw9kYF9y_-pNn5BB1nj_xm6qLHytATdJPSLzXetweC07_raj3VNCVVnWwg9w
                    // lTw6iwOMJcY8iYQuRWbGM9k7bTqynhypwdIdwIQcit9JxGApWNh-7lMp6jkLsrl5GodCkGlv8fwjR-Xiqr8nMw
                      waterCorpId: 3,
                      UNID: '',
                      areaId: 0,
                      appVersion: '1.0.2',
                      apiType: window.localStorage.getItem('apiType')?window.localStorage.getItem('apiType'):"WX"
                    //   clientType:"iOS",
                    //   htmlVersion:"1.0.4", 
                    }
        // if (isWeiXin()) {
        //     target.apiType = 'JSAPI'
        // }else{
        //     target.apiType = 'APP'
        // }
        // target.token = "BUb8uVOhP9JhHml9wwq-rQ2jqnd4TS10xbu-45CU5cGUYJFd5uy9W6tay2p87Iu234tHUiHQsSG3OPk3qNbArQ"
        let params = Object.assign(config.params, target)
        config.params = {
            requestPara: params
        }
        startLoading()
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);
// service
service.interceptors.response.use(
    response => {
        endLoading()
        return response.data;
    },
    error => {
        endLoading()
        if (!error.response) {
            return Promise.reject(error);
        }
        return Promise.reject(error);
    }
);

export default service;
